import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const setup = () => {
  const triggers = document.querySelectorAll('.w-b-tower-scroll-scene');
  if (triggers.length === 0) return;

  let mediaManager = gsap.matchMedia();
  mediaManager.add(
    {
      isMobile: `(max-width: 768px), (min-width: 768px) and (max-width: 1366px) and (orientation: portrait)`,
      isDesktop: `(min-width: 768px) and (max-width: 1366px) and (orientation: landscape), (min-width: 1366px)`,
    },
    (context) => {
      let { isDesktop, isMobile } = context.conditions;

      if (isMobile) {
        triggers.forEach((trigger) => {
          gsap.to(trigger, {
            scrollTrigger: {
              trigger: trigger,
              start: 'top top',
              end: '+=50%',
              scrub: true,
              onUpdate: (self) => {
                // const progress = gsap.parseEase('power1.inOut')(self.progress);
                const progress = self.progress;
                trigger.style.setProperty('--_scroll', `${progress * 100}%`);
              },
            },
          });
        });
      } else if (isDesktop) {
        triggers.forEach((trigger) => {
          // const header = trigger.querySelector('[data-w-tower-scroll-header]');

          gsap.to(trigger, {
            scrollTrigger: {
              trigger: trigger,
              start: 'top top',
              end: 'top top-=100%',
              scrub: true,
              onUpdate: (self) => {
                const progress = gsap.parseEase('power1.inOut')(self.progress);
                trigger.style.setProperty('--_scroll', `${progress * 100}%`);
              },
            },
          });

          const paragraphParent = trigger.querySelector(
            '[data-w-tower-scroll-scene-title]'
          );
          const paragraphs = paragraphParent.querySelectorAll('& > *');

          gsap.to(paragraphs, {
            y: '-75%',
            opacity: 0,
            scale: 0.875,
            ease: 'power1.in',
            scrollTrigger: {
              trigger: paragraphParent,
              start: 'bottom bottom',
              end: 'bottom center',
              scrub: true,
              fastScrollEnd: true,
            },
          });
        });
      }
    }
  );
};

export default function TowerScrollScene() {
  return {
    init: () => {
      setup();
    },
  };
}
